import Endpoints from '@/config/ApiEndpoints.js';	
import Axios from 'axios';
import $ from 'jquery'; 
import VehicleRegistrationRegion from "@/assets/js/vehicle_registration_region.js";
import UpcomingEvent from '@/pages/upcomingevent/upcomingevent';
import VehicleOverView from '@/pages/vehicles/vehicleoverview/vehicleoverview';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Task from "@/pages/task/task";
var moment = require("moment");
export default {
	components:{
		UpcomingEvent,
		VuePerfectScrollbar,
		VehicleOverView,
		Task,
	},
	filters: {
        date: function(data) {
			var sendDate = "N/A";
			if (data != "" && data != null) {
				sendDate = moment(data).format("DD-MM-YYYY");
			}
			return sendDate;
        },
		region: function(data){
			return VehicleRegistrationRegion(data);
		}
    },
	data() {
		return {
			settings4: {
				maxScrollbarLength: 60,
				suppressScrollY: true,
			},
			CompanyData:"",
			SearchLoader: false,
			ShowLoader: false,
			UnsafeShowLoader: false,
			SearchKey: '',
			VehicleImageEndpoint: Endpoints.Helper.GenerateImage+ '/',
			ImageEndpoint: Endpoints.Helper.Image+ '/',
			Trailers:[],
			trailer_export_data:[],
			Make:{},
			Models:{},
			TrailerTypes:{},
			UpcomingEvent: {},
			DashboardData: {},
			DashboardReportData:{},
			DashboardDetailHeading:'',
			VehicleWarningCnt: 0,
			SearchData:{
				trailer_type:"",
				make:"",
				model:"",
				branch_id:"",
			},
			ActivityPage: 1,
			LastPageRequest: 0,
			ShowUrgentTask: false,
			ShowTrailerDetails: false,
			Branches: {},
			todaysUrgentTaskNew: window.todaysUrgentTaskNew,
		}
		
	},	
	created() {
		//window.addEventListener('scroll', this.handleScroll);
	},
	destroyed() {
		//window.removeEventListener('scroll', this.handleScroll);
	},	
	mounted() {		
		var AccountPermissions = JSON.parse(
		localStorage.getItem("AccountPermissions")
		);
		this.FleetSubscription = JSON.parse(
		localStorage.getItem("FleetSubscription")
		);
		var FleetSubscriptionModules = JSON.parse(
		this.FleetSubscription.fleet_modules
		);
		if(FleetSubscriptionModules["Hierarchy System"] && (!AccountPermissions.Trailers || !AccountPermissions.Trailers.enable)){
		this.$router.push('/');
		}
		
		if (AccountPermissions && 
			AccountPermissions.Trailers &&
			AccountPermissions.Trailers.enable) {
			if ( AccountPermissions.Trailers.view) {
				this.ShowTrailerDetails = true;
			}
		}
		
		if (AccountPermissions && 
			AccountPermissions['Vehicle Checks'] &&
			AccountPermissions['Vehicle Checks']['enable']) {
			if ( AccountPermissions['Vehicle Checks']['view_urgent_task']) {
				this.ShowUrgentTask = true;
			}
		}

		if (!FleetSubscriptionModules["Hierarchy System"]) {
			this.ShowUrgentTask = true;
			this.ShowTrailerDetails = true;
		}
		this.CompanyData = JSON.parse(localStorage.getItem("Company"));
		if (this.CompanyData && this.CompanyData.name) {            
		  if(window.taskModuleCompanies.includes(this.CompanyData.id)){ 
	      	this.todaysUrgentTaskNew = true
	      }
	    } 
     			
		this.GetTrailersList();
		this.GetUnSafeTrailer();
		this.GetMake();
		this.GetModel();
		this.GetTrailerTypes();
		this.GetBranches();
	},
	methods : {
		
		handleScroll() {
			let scrollBottom = document.body.scrollHeight;
			let bottomOfWindow = scrollBottom >= window.scrollY;
			if (bottomOfWindow) {
				this.GetTrailersList();
			}
		},
		GetUnSafeTrailer() {
			Axios.post(Endpoints.Dashboard.DashboardReportData, {
			  token: localStorage.getItem("token"),
			  type: 'vehicleunsafe',
			  item_type:'TrailerList'
			}).then((Response) => {
			  if (Response.data.success) {
				this.DashboardReportData = Response.data.DashboardReportData;
			  }
			});
		  },
		GetBranches() {
			var obj = { token: localStorage.getItem("token"), select_branch: true };
			Axios.post(Endpoints.Branch.List, obj).then((Response) => {
			  if (Response.data.success) {
				this.Branches = Response.data.records;
			  }
			});
		  },
		
		GetMake(){
			var obj = { token: localStorage.getItem("token") };
			Axios.post(Endpoints.Trailer.GetTrailerMake, obj).then((Response) => {
				if (Response.data.success) {
					this.Make = Response.data.records;
				}
			});
		},
		GetModel(){
			
			var obj = { token: localStorage.getItem("token")};
			Axios.post(Endpoints.Trailer.GetTrailerModel, obj).then((Response) => {
				if (Response.data.success) {
					this.Models = Response.data.records;
				}
			});
		},
		GetTrailerTypes(){
			var obj = { token: localStorage.getItem("token") };
			Axios.post(Endpoints.Trailer.GetTrailerTypes, obj).then((Response) => {
				if (Response.data.success) {
					this.TrailerTypes = Response.data.records;
				}
			});
		},
		SearchTrailer(){
			this.Trailers = [];
			this.ActivityPage = 1;
			this.LastPageRequest = 0;
			this.GetTrailersList('search');
		},
		GetTrailersList(type=''){
			var self = this;
      		if (this.ActivityPage > 0 && this.LastPageRequest != this.ActivityPage) {
				this.SearchLoader = true;
				this.LastPageRequest = this.ActivityPage;
				var obj = {
				token: localStorage.getItem("token"),
				};
				if(type=='search'){
					if(this.SearchKey != ""){
						obj.searchkey = this.SearchKey
					}
					obj.SearchData = this.SearchData;
				}
				this.ShowLoader=true;
				Axios.post(Endpoints.Trailer.List, obj).then((Response) => {
					this.ShowLoader=false;
					if (Response.data.success) {
						this.SearchLoader = false;	
						this.Trailers = Response.data.trailers;
						this.trailer_export_data = [];
						if (this.Trailers.length > 0) {
						this.Trailers.forEach((element2) => {
							var obj = {};
							obj["Reg No"] = element2.vrm;
							obj["Make"] = element2.make;
							obj["Model"] = element2.model;
							this.trailer_export_data.push(obj);
						});
						}

						/*if (Response.data.trailers.data.length > 0) {
							Response.data.trailers.data.forEach((record) => {
								self.Trailers.push(record);
							});
						}
						this.ActivityPage = Response.data.nextPage;*/
					}
				});
			}
		},
	},
	
}